var map = {
	"./APITesting": [
		8461,
		8461
	],
	"./APITesting.jsx": [
		8461,
		8461
	],
	"./Accountant/Categories": [
		5254,
		5254
	],
	"./Accountant/Categories.jsx": [
		5254,
		5254
	],
	"./Accountant/DashBoard": [
		7756,
		7756
	],
	"./Accountant/DashBoard.jsx": [
		7756,
		7756
	],
	"./Accountant/Earning": [
		1098,
		1098
	],
	"./Accountant/Earning.jsx": [
		1098,
		1098
	],
	"./Accountant/Expenses": [
		3207,
		2019,
		3207
	],
	"./Accountant/Expenses.jsx": [
		3207,
		2019,
		3207
	],
	"./Accountant/SetUp": [
		2831,
		2831
	],
	"./Accountant/SetUp.jsx": [
		2831,
		2831
	],
	"./AdavncedPaymentReciept": [
		6407,
		6407
	],
	"./AdavncedPaymentReciept.jsx": [
		6407,
		6407
	],
	"./Admin/Refund": [
		4435,
		4435
	],
	"./Admin/Refund.jsx": [
		4435,
		4435
	],
	"./Appointments": [
		5139,
		7014,
		1453,
		5139
	],
	"./Appointments.jsx": [
		5139,
		7014,
		1453,
		5139
	],
	"./Assistant": [
		2676,
		2676
	],
	"./Assistant/": [
		2676,
		2676
	],
	"./Assistant/index": [
		2676,
		2676
	],
	"./Assistant/index.jsx": [
		2676,
		2676
	],
	"./Assistant/tokens": [
		9340,
		9340
	],
	"./Assistant/tokens.jsx": [
		9340,
		9340
	],
	"./Authentication": [
		3208
	],
	"./Authentication/": [
		3208
	],
	"./Authentication/AppointmentTokens": [
		9042,
		9042
	],
	"./Authentication/AppointmentTokens.jsx": [
		9042,
		9042
	],
	"./Authentication/Forgot": [
		1963,
		1963
	],
	"./Authentication/Forgot.jsx": [
		1963,
		1963
	],
	"./Authentication/Login": [
		5215,
		5215
	],
	"./Authentication/Login.jsx": [
		5215,
		5215
	],
	"./Authentication/NewPassword": [
		1705,
		1705
	],
	"./Authentication/NewPassword.jsx": [
		1705,
		1705
	],
	"./Authentication/index": [
		3208
	],
	"./Authentication/index.jsx": [
		3208
	],
	"./Doctor/AddDiseases": [
		2017,
		2017
	],
	"./Doctor/AddDiseases.jsx": [
		2017,
		2017
	],
	"./Doctor/ChiefOFComplaint": [
		2606,
		2606
	],
	"./Doctor/ChiefOFComplaint.jsx": [
		2606,
		2606
	],
	"./Doctor/Dashboard": [
		897,
		2019,
		897
	],
	"./Doctor/Dashboard.jsx": [
		897,
		2019,
		897
	],
	"./Doctor/PatientsReview": [
		5171,
		7014,
		5737,
		6636,
		6767
	],
	"./Doctor/PatientsReview.jsx": [
		5171,
		7014,
		5737,
		6636,
		6767
	],
	"./Doctor/Perscription": [
		7218,
		7014,
		5737,
		1414
	],
	"./Doctor/Perscription.jsx": [
		7218,
		7014,
		5737,
		1414
	],
	"./Homepage": [
		9717,
		9717
	],
	"./Homepage.jsx": [
		9717,
		9717
	],
	"./Ipd/DashBoard": [
		3421,
		3421
	],
	"./Ipd/DashBoard.jsx": [
		3421,
		3421
	],
	"./Ipd/DischargeCard": [
		247,
		247
	],
	"./Ipd/DischargeCard.jsx": [
		247,
		247
	],
	"./Ipd/DischargeReportForm": [
		3877,
		3877
	],
	"./Ipd/DischargeReportForm.jsx": [
		3877,
		3877
	],
	"./Ipd/DosingSchedule": [
		2408,
		2408
	],
	"./Ipd/DosingSchedule.jsx": [
		2408,
		2408
	],
	"./Ipd/IpdVisits": [
		6004,
		6004
	],
	"./Ipd/IpdVisits.jsx": [
		6004,
		6004
	],
	"./Ipd/PatientSchedule": [
		529,
		529
	],
	"./Ipd/PatientSchedule.jsx": [
		529,
		529
	],
	"./Ipd/Patients": [
		4679,
		4679
	],
	"./Ipd/Patients.jsx": [
		4679,
		4679
	],
	"./Ipd/ReportSummary": [
		9183,
		9183
	],
	"./Ipd/ReportSummary.jsx": [
		9183,
		9183
	],
	"./Ipd/SummaryReport": [
		2571,
		2571
	],
	"./Ipd/SummaryReport.jsx": [
		2571,
		2571
	],
	"./Lab/Dashboard": [
		4485,
		7014,
		5737,
		1453,
		8365
	],
	"./Lab/Dashboard.jsx": [
		4485,
		7014,
		5737,
		1453,
		8365
	],
	"./Lab/Reports": [
		9844,
		7014,
		5737,
		1453,
		9572
	],
	"./Lab/Reports.jsx": [
		9844,
		7014,
		5737,
		1453,
		9572
	],
	"./PatientProfile": [
		1235,
		5737,
		8271
	],
	"./PatientProfile.jsx": [
		1235,
		5737,
		8271
	],
	"./Patients": [
		3527,
		3527
	],
	"./Patients.jsx": [
		3527,
		3527
	],
	"./Payments": [
		7272,
		7014,
		1453,
		7272
	],
	"./Payments.jsx": [
		7272,
		7014,
		1453,
		7272
	],
	"./Pharmacist/AddMedicine": [
		1865,
		1865
	],
	"./Pharmacist/AddMedicine.jsx": [
		1865,
		1865
	],
	"./Pharmacist/AddPurchase": [
		642,
		642
	],
	"./Pharmacist/AddPurchase.jsx": [
		642,
		642
	],
	"./Pharmacist/Dashboard": [
		5386,
		2019,
		5386
	],
	"./Pharmacist/Dashboard.jsx": [
		5386,
		2019,
		5386
	],
	"./Pharmacist/GenerateInvoice": [
		5588,
		5588
	],
	"./Pharmacist/GenerateInvoice.jsx": [
		5588,
		5588
	],
	"./Pharmacist/MedicineTable": [
		9626,
		9626
	],
	"./Pharmacist/MedicineTable.jsx": [
		9626,
		9626
	],
	"./Pharmacist/Medicines": [
		2314,
		2314
	],
	"./Pharmacist/Medicines.jsx": [
		2314,
		2314
	],
	"./Pharmacist/Purchases": [
		2874,
		2874
	],
	"./Pharmacist/Purchases.jsx": [
		2874,
		2874
	],
	"./PrintAppointment": [
		6501,
		7014,
		6501
	],
	"./PrintAppointment.jsx": [
		6501,
		7014,
		6501
	],
	"./Reception/Addmissions": [
		8183,
		8183
	],
	"./Reception/Addmissions.jsx": [
		8183,
		8183
	],
	"./Reception/Appointment": [
		8017
	],
	"./Reception/Appointment/": [
		8017
	],
	"./Reception/Appointment/Appointment": [
		1442
	],
	"./Reception/Appointment/Appointment.jsx": [
		1442
	],
	"./Reception/Appointment/Patient": [
		6036
	],
	"./Reception/Appointment/Patient.jsx": [
		6036
	],
	"./Reception/Appointment/index": [
		8017
	],
	"./Reception/Appointment/index.jsx": [
		8017
	],
	"./Reception/CreateIPDBill": [
		1397,
		1397
	],
	"./Reception/CreateIPDBill.jsx": [
		1397,
		1397
	],
	"./Reception/Dashboard": [
		9775,
		7014,
		2019,
		1453,
		9775
	],
	"./Reception/Dashboard.jsx": [
		9775,
		7014,
		2019,
		1453,
		9775
	],
	"./Reception/IPDBilling": [
		3633,
		3633
	],
	"./Reception/IPDBilling.jsx": [
		3633,
		3633
	],
	"./Reception/NextVisit": [
		6815,
		6815
	],
	"./Reception/NextVisit.jsx": [
		6815,
		6815
	],
	"./Reception/PrintIPDBill": [
		3562,
		3562
	],
	"./Reception/PrintIPDBill.jsx": [
		3562,
		3562
	],
	"./Reception/Reports": [
		7598,
		7598
	],
	"./Reception/Reports.jsx": [
		7598,
		7598
	],
	"./Sample": [
		9627,
		9627
	],
	"./Sample.jsx": [
		9627,
		9627
	],
	"./Setting": [
		7386,
		7386
	],
	"./Setting.jsx": [
		7386,
		7386
	],
	"./SuperAdmin/Dashboard": [
		4130,
		4130
	],
	"./SuperAdmin/Dashboard.jsx": [
		4130,
		4130
	],
	"./SuperAdmin/Expense": [
		1454,
		1454
	],
	"./SuperAdmin/Expense.jsx": [
		1454,
		1454
	],
	"./SuperAdmin/Income": [
		1213,
		1213
	],
	"./SuperAdmin/Income.jsx": [
		1213,
		1213
	],
	"./SuperAdmin/Rooms": [
		7722,
		7722
	],
	"./SuperAdmin/Rooms.jsx": [
		7722,
		7722
	],
	"./SuperAdmin/Services": [
		5748,
		5748
	],
	"./SuperAdmin/Services.jsx": [
		5748,
		5748
	],
	"./SuperAdmin/Users": [
		950,
		950
	],
	"./SuperAdmin/Users.jsx": [
		950,
		950
	],
	"./Templates/AppointmentCard": [
		6636,
		7014,
		5737,
		6636,
		4313
	],
	"./Templates/AppointmentCard.jsx": [
		6636,
		7014,
		5737,
		6636,
		4313
	],
	"./Templates/AppointmentTemplates": [
		1453,
		7014,
		1453
	],
	"./Templates/AppointmentTemplates.jsx": [
		1453,
		7014,
		1453
	],
	"./Templates/MedicineInvoice": [
		922,
		922
	],
	"./Templates/MedicineInvoice.jsx": [
		922,
		922
	],
	"./Templates/PaymentReceipt": [
		2960,
		579
	],
	"./Templates/PaymentReceipt.jsx": [
		2960,
		579
	],
	"./TokenDistribution": [
		6700,
		6700
	],
	"./TokenDistribution.jsx": [
		6700,
		6700
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 629;
module.exports = webpackAsyncContext;